import React, { useEffect } from 'react'
import { withRouter } from 'react-router'
import { Layout } from 'antd'
import { HashRouter as Router, Route } from 'react-router-dom'
import { ApolloProvider as ApolloHooksProvider } from '@apollo/react-hooks'
import { ApolloProvider } from 'react-apollo'
import cubejs from '@cubejs-client/core'
import { CubeProvider } from '@cubejs-client/react'
import { Hub } from 'aws-amplify'
import HasAccess from 'core/HasAccess'
import { setUser } from 'core/user'
import { connect } from 'react-redux'
import { getCubeServerUrl } from 'utils/paths'
import client from './graphql/client'
import Header from './components/Header'
import CommonPage from './pages/CommonPage'

const connector = connect(
  ({ user, currentLenderId }) => ({ user, currentLenderId }),
  { setUser },
)
const cubejsApi = cubejs('SECRET', {
  credentials: 'include',
  method: 'POST',
  apiUrl: `${getCubeServerUrl()}/cubejs-api/v1`,
})

Hub.listen('auth', (data) => {
  if (data.payload.event === 'signOut') {
    client.resetStore()
  }
})

const AppLayout = withRouter(({ location, children }) => (
  <Layout style={{ height: '100%' }}>
    <Header location={location} />
    <Layout.Content style={{ marginTop: '60px' }}>{children}</Layout.Content>
  </Layout>
))

const App = ({ setUser, user, currentLenderId }) => {
  useEffect(() => {
    const deployedBuildVersion = localStorage.getItem('build-version')
    if (process.env.REACT_APP_BUILD_VERSION !== deployedBuildVersion) {
      localStorage.clear()
      localStorage.setItem('build-version', process.env.REACT_APP_BUILD_VERSION)
    }
    setUser()
  }, [])

  useEffect(() => {
    const handleRefresh = (e) => {
      e.preventDefault()
      localStorage.clear()
      localStorage.setItem('build-version', process.env.REACT_APP_BUILD_VERSION)
      window.location.reload()
    }
    window.addEventListener('beforeunload', handleRefresh)
    return () => window.removeEventListener('beforeunload', handleRefresh)
  }, [])

  return (
    <Router>
      <CubeProvider cubejsApi={cubejsApi}>
        <ApolloProvider client={client}>
          <ApolloHooksProvider client={client}>
            <AppLayout location={location}>
              {!!user.lenders.length && HasAccess.run(user.permissions, 'lpCompetitiveResi') && (
                <Route
                  render={() => (
                    <CommonPage
                      name="resiCommon"
                      currentLenderId={currentLenderId}
                    />
                  )}
                  exact
                  key="resi-common"
                  path="/"
                />
              )}
              {!!user.lenders.length && HasAccess.run(user.permissions, 'lpCompetitiveBtl') && (
                <Route
                  render={() => (
                    <CommonPage
                      name="btlCommon"
                      currentLenderId={currentLenderId}
                    />
                  )}
                  exact
                  key="btl-common"
                  path="/btl"
                />
              )}
            </AppLayout>
          </ApolloHooksProvider>
        </ApolloProvider>
      </CubeProvider>
    </Router>
  )
}

export default connector(App)
